import { z } from 'zod';
/**
 * 인증된 일반 사용자에게 노출되는 UI 토글 모음.
 * 관리자 settings 의 부분집합으로, GET /api/app/settings 가 반환한다.
 */
export const PublicAppSettingsSchema = z.object({
    /** 채팅 UI 에서 어시스턴트 답변 옆에 응답 소요 시간을 표시할지 여부. */
    showResponseTime: z.boolean(),
    /** 어시스턴트 페르소나 이름 — 챗 빈 화면 인사말과 자기소개에 사용. */
    personaName: z.string(),
    /** 사용자 사이드바 '지식 위키' 메뉴 노출 여부. */
    wikiEnabled: z.boolean(),
    /** 채팅 화면 모델 선택 버튼 노출 여부. false 면 버튼이 숨겨지고 기본 모델만 사용된다. */
    userModelSelectionEnabled: z.boolean(),
    /** 문서보안(DRM) 활성 환경 여부. true 면 업로드가 보안 적용 가능한 확장자로 제한된다. */
    drmActive: z.boolean(),
    /**
     * 채팅 첨부 업로드 허용 확장자 (점 없는 소문자, 예: ['xlsx','pdf','docx']).
     * 서버가 DRM 활성 여부를 반영해 계산 — 클라이언트는 accept/검증에 그대로 사용한다.
     */
    uploadAllowedExts: z.array(z.string()),
});
//# sourceMappingURL=app-settings.js.map